/**
 * Content block for ConfirmModal (message, requireConfirmation, error).
 * Extracted to keep ConfirmModal under max-lines-per-function.
 */

import React, { ChangeEvent } from "react";
import Typography, { ETypo, ETypoColor } from "../../Typography";
import { ConfirmModalRequireConfirmationBlock } from "./ConfirmModalRequireConfirmationBlock";
import blocks from "./confirmModalBlocks.module.scss";

type ConfirmModalContentProps = {
	message?: string | React.ReactNode;
	content?: React.ReactNode;
	requireConfirmation?: {
		enabled: boolean;
		label: string;
		placeholder: string;
		expectedValue: string;
	};
	confirmationValue: string;
	onConfirmationChange: (event: ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
	error?: string | null;
};

export function ConfirmModalContent(props: ConfirmModalContentProps): React.JSX.Element {
	const { message, content, requireConfirmation, confirmationValue, onConfirmationChange, error } = props;

	return (
		<>
			{content || (message && <Typography typo={ETypo.TEXT_MD_REGULAR}>{message}</Typography>)}

			{requireConfirmation?.enabled && (
				<ConfirmModalRequireConfirmationBlock
					enabled={requireConfirmation.enabled}
					label={requireConfirmation.label}
					placeholder={requireConfirmation.placeholder}
					expectedValue={requireConfirmation.expectedValue}
					confirmationValue={confirmationValue}
					onConfirmationChange={onConfirmationChange}
				/>
			)}

			{error && (
				<Typography typo={ETypo.TEXT_SM_REGULAR} color={ETypoColor.COLOR_ERROR_500} className={blocks["errorText"]}>
					{error}
				</Typography>
			)}
		</>
	);
}
